// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__ZAF5J","rowBlock":"styles_rowBlock__nXN4Y"};